export type FormStepProps = {
  formState: any;
  handleChange: (e: React.FormEvent<HTMLFormElement>) => void;
  handleBlur: (
    e: React.FormEvent<HTMLFormElement>,
    validation: (any) => boolean | string,
    customInput?: any
  ) => void;
  setFormStep: React.Dispatch<React.SetStateAction<number>>;
}

export const validateName = (name) => {
  if (!name) {
    return 'Please provide your name.'
  }
  if (name.length < 2) {
    return 'Cannot be shorter than 2 characters.'
  }
  return false
}

export const validateLength = (input) => {
  if (!input) {
    return 'Please fill this field.'
  }
  if (input.length < 2) {
    return 'Cannot be shorter than 2 characters.'
  }
  return false
}

export const validateEmail = (email) => {
  if (!email) {
    return 'Please provide an email.'
  }
  if (email.length < 5) {
    return 'The provided email is not valid.'
  }
  return false
}

export const validatePassword = (password) => {
  if (!password) {
    return 'Please provide a password.'
  }
  if (password.length < 6) {
    return 'Password must be longer than 6 characters.'
  }
  return ''
}

export const validateConfirmPassword = (passwords) => {
  if (!passwords[1]) {
    return 'Please confirm your password.'
  }
  if (passwords[0] !== passwords[1]) {
    return 'Passwords must match.'
  }
  return ''
}

export const validatePhone = (phone) => {
  if (!phone) {
    return false
  }
  if (phone.length < 5) {
    return 'Phone number must be longer than 5 characters.'
  }
  if (!phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
    return 'Phone number must be in this format: xxx-xxx-xxxx'
  }
  return false
}

export const validateFacebookURL = (url) => {
  if (!url) {
    return false
  }
  if (url.length < 5) {
    return 'This is not a valid URL'
  }
  return false
}

export const validateInstagramURL = (url) => {
  if (!url) {
    return false
  }
  if (url.length < 5) {
    return 'This is not a valid URL'
  }
  return false
}
